import { render } from "./CatalogElement.vue?vue&type=template&id=032aaa53&scoped=true"
import script from "./CatalogElement.vue?vue&type=script&lang=js"
export * from "./CatalogElement.vue?vue&type=script&lang=js"

import "./CatalogElement.vue?vue&type=style&index=0&id=032aaa53&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032aaa53"]])

export default __exports__